import React, { useEffect } from 'react';

import { Banana, Cabbage, Earth, Mango } from '../../ui-library/typography';
import { Space } from '../../ui-library/space';
import StyledContainer from '../../ui-library/styled/StyledContainer';
import useScroll from '../../utils/useScroll';
import useTitle from '../../utils/useTitle';

const PrivacyPolicyPage = () => {
  const { scrollToId } = useScroll();

  useTitle();

  useEffect(() => {
    setTimeout(() => {
      scrollToId('privacy-policy');
    }, 100);
  }, []);

  return (
    <StyledContainer id='privacy-policy'>
      <Space size={16} />
      <Cabbage>Privacy Policy</Cabbage>
      <Earth>
        <b>Effective Date:</b> October 15, 2021
      </Earth>
      <Earth marginBottom='16px'>
        <b>Last Modified Date:</b> October 15, 2021
      </Earth>
      <Earth marginBottom='16px'>
        This Privacy Policy describes how AskOkey collects, uses and discloses
        information when you use our services, client software and websites
        ("Services").
      </Earth>
      <Mango>Account Information</Mango>
      <Earth marginBottom='16px'>
        You create an account on AskOkey using your email id. When you purchase
        a product from AskOkey, you provide your phone number and physical
        address. These details are used by us to provide our Services to you.
      </Earth>
      <Mango>Personal Information</Mango>
      <Earth marginBottom='16px'>
        Our Services are designed as a simple way for you to order our products
        customized to your needs. To make this possible, we collect, store,
        process, and transmit your registered details as well as all information
        related to your order. Additional technical information may be collected
        to analyze how you make use of our Services in order to improve our
        Services.
      </Earth>
      <Mango>User Support</Mango>
      <Earth marginBottom='16px'>
        If you contact AskOkey User Support, any personal data you may share
        with us is kept only for the purposes of researching the issue and
        contacting you about your case.
      </Earth>
      <Mango>Managing your Information</Mango>
      <Earth marginBottom='64px'>
        You can manage your personal information in AskOkey’s Profile Settings.
      </Earth>

      <Banana marginBottom='16px'>Information we may share</Banana>
      <Mango>Third Parties</Mango>
      <Earth marginBottom='16px'>
        We work with third parties to provide some of our Services. We may share
        limited information with our tailors and other third party vendors but
        only to the minimum required for them to provide our Services. For
        example, our Shipping Providers will handle the physical delivery of
        products you order at AskOkey and will be provided with the required
        information to process your order. These providers are bound by their
        Privacy Policies to safeguard that information.
      </Earth>
      <Earth marginBottom='64px'>
        Other instances where AskOkey may need to share your data To meet any
        applicable law, regulation, legal process or enforceable governmental
        request.
        <ul>
          <li>
            To enforce applicable Terms, including investigation of potential
            violations.
          </li>
          <li>
            To detect, prevent, or otherwise address fraud, security, or
            technical issues.
          </li>
          <li>
            To protect against harm to the rights, property, or safety of
            AskOkey, our users, or the public as required or permitted by law.
          </li>
        </ul>
      </Earth>
      <Banana marginBottom='16px'>Updates</Banana>
      <Earth>
        We will update this privacy policy as needed so that it is current,
        accurate, and as clear as possible. Your continued use of our Services
        confirms your acceptance of our updated Privacy Policy.
      </Earth>
    </StyledContainer>
  );
};

export default PrivacyPolicyPage;
